import {Component} from 'react';
import "./ForParents/forParents.css";
import "../../css/styles.css";
import VideoViewerModal from './video_viewer_modal';


class DiscussionTopics extends Component {
    constructor(props) {
        super(props);
        this.state={
           modalOpen: false,
             
        };  
    }
    
    render() {
        this.tableElementClass = "col text-center";
                                          
    return <>
           <div className="col-8">
                <div className="card mt-3 mr-5 rounded-corners-lg h-100">
                    <button className="pages-back-button ml-4 mt-4" 
                        onClick ={()=> this.props.goBack()}>
                                Back
                    </button>
                    <h3 className="mt-0 p-0 text-center">Video Presentations</h3>
                                   
                    <div className="mx-5 mt-2">
                         Explore key Financial Literacy concepts with these fun, informative videos!
                         Perfect for classrooms or solo players, they reinforce what you’ve learned in the MoneyTrain game.
                        🎧 Don’t forget to turn on your sound!
                    </div>
                    <span>
                        <div className="row mt-2">
                            <div className={this.tableElementClass}>
                                <button className="btn-group-medium mt-2 cursor-is-pointer" 
                                    onClick ={()=> this.topicSelected("introduction")}>
                                        Before You Play 
                                        <div className="small-text">(3 minutes)</div>
                                </button>
                            </div>
                            <div className={this.tableElementClass}>
                                <button className="btn-group-medium mt-2 cursor-is-pointer" 
                                    onClick ={()=> this.topicSelected("theBasics")}>
                                            Financial Literacy Overview
                                            <div className="small-text">(4 minutes)</div>
                                    </button>
                            </div>
                             <div className={this.tableElementClass}>
                               <button className="btn-group-medium mt-2 cursor-is-pointer" 
                                    onClick ={()=> this.topicSelected("foundations")}>
                                            Foundations
                                            <div className="small-text">(5 minutes)</div>
                                </button>
                            </div> 
                        </div>  
                        <div className="row mt-2">
                            <div className={this.tableElementClass}>
                                <button className="btn-group-medium mt-3 cursor-is-pointer" 
                                    onClick ={()=> this.topicSelected("needsVsWants")}>
                                            Needs vs. Wants 
                                        <div className="small-text">(7 minutes)</div>
                                </button>
                            </div>
                            <div className={this.tableElementClass}>
                                <button className="btn-group-medium mt-3 cursor-is-pointer" 
                                    onClick ={()=> this.topicSelected("jobChoice")}>
                                        Job Choice 
                                        <div className="small-text">(6 minutes)</div>
                                </button>
                            </div>
                            <div className={this.tableElementClass}>
                                <button className="btn-group-medium mt-3 cursor-is-pointer" 
                                    onClick ={()=> this.topicSelected("homeChoice")}>
                                        Home Choice
                                    <div className="small-text"> (6 minutes)</div>
                                </button>
                            </div>
                        </div>
                        <div className="row mt-2">
                             <div className={this.tableElementClass}>
                                <button className="btn-group-medium mt-3 cursor-is-pointer" 
                                    onClick ={()=> this.topicSelected("carChoice")}>
                                        Car Choice
                                    <div className="small-text"> (6 minutes)</div>
                                </button>
                            </div>
                            <div className={this.tableElementClass}>
                                <button className="btn-group-medium mt-3 cursor-is-pointer" 
                                    onClick ={()=> this.topicSelected("investments")}>
                                        Investments 
                                        <div className="small-text">(5 minutes)</div>
                                </button>
                            </div>
                            <div className={this.tableElementClass}>
                                <button className="btn-group-medium mt-3 cursor-is-pointer" 
                                    onClick ={()=> this.topicSelected("insurance")}>
                                        Insurance 
                                    <div className="small-text"> (6 minutes)</div>
                                </button>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-sm-4 text-center">
                            </div>
                            <div className="col-sm-4 text-center">
                                <button className="btn-group-medium mt-3 cursor-is-pointer" 
                                    onClick ={()=> this.topicSelected("wrapUp")}>
                                        Wrap-up
                                    <div className="small-text">(3 minutes)</div>
                                </button>
                            </div>
                        </div>
                    </span>
                                              
                                                                
                    {this.state.modalOpen ?
                        <div className="video-display-size" >
                            <VideoViewerModal
                                topicName={this.topicName}
                                show={this.state.modalOpen}
                                onClose={() => this.turnVideoOff()} 
                            />
                        </div>
                    :
                        null
                    }

                                      
                </div>        
            </div>
        </>
    }
    
    topicSelected(topicName){
        this.topicName = topicName;
        this.setState({modalOpen: true});
    }

    turnVideoOff(){
        this.powerPointVideo = "";
        this.setState({modalOpen: false});
    }


}

export default DiscussionTopics;